var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"max-width":"300px"},model:{value:(_vm.showDialog),callback:function ($$v) {_vm.showDialog=$$v},expression:"showDialog"}},[_c('video',{attrs:{"controls":"","controlsList":"nodownload","playsinline":"","autoplay":"","loop":"","src":_vm.srcDialog},on:{"contextmenu":function($event){$event.preventDefault();}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }